'use client';

import React from 'react';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import BuildertonSection from './BuildertonSection';
import MentorsSection from './MentorsSection';
import PricingPreviewSection from './PricingPreviewSection';
import TrustSignalsSection from './TrustSignalsSection';
import CTASection from './CTASection';
import FooterSection from './FooterSection';
import Header from '@/components/common/Header';

const LandingPageInteractive = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <BuildertonSection />
        <MentorsSection />
        <PricingPreviewSection />
        <TrustSignalsSection />
        <CTASection />
        <FooterSection />
      </main>
    </>
  );
};

export default LandingPageInteractive;
